import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetCrewDeliveryPdfQuery } from '../../../redux/api/crewDeliveryApi';

// Standalone full-page preview of a crew delivery note, reachable at
// /crew-delivery/:deliveryId/pdf. The detail view's buttons open and print the
// same PDF without leaving the page.
const CrewDeliveryPdf = () => {
  const { deliveryId } = useParams();
  const { data: pdfBlob, error, isLoading } = useGetCrewDeliveryPdfQuery(deliveryId);
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    if (!pdfBlob) return undefined;
    const url = window.URL.createObjectURL(pdfBlob);
    setPdfUrl(url);
    return () => window.URL.revokeObjectURL(url);
  }, [pdfBlob]);

  if (isLoading) {
    return <div>Lieferschein wird geladen …</div>;
  }

  if (error) {
    return <div>Lieferschein konnte nicht geladen werden.</div>;
  }

  if (!pdfUrl) return null;

  return (
    <object data={pdfUrl} type='application/pdf' width='100%' height='2000px'>
      <p>
        Dieser Browser kann PDFs nicht anzeigen. Bitte den Lieferschein
        herunterladen.
      </p>
    </object>
  );
};

export default CrewDeliveryPdf;
